import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import styles from './index.css';
import { classnames } from '../../utils/classnames';
import Header from '../../components/header';
import Nav from './nav';
import NewsStream from './newsstream';
import RightNav from './rightNav';
import ContactUs from './contactUs';
import BottomFooter from './bottomFooter';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
    }

    render() {
        const { content } = this.props;
        const navData = {
            channel: content.channel,
            topNav: content.topNav,
            topNavId: content.topNavId,
            columnId: content.columnId,
        };
        const newStreamData = {
            newsstream: content.newsstream,
            page: content.page,
            endPage: content.endPage,
            columnId: content.columnId,
        };
        const bottomFooterData = {
            cooperation: content.cooperation,
            footer: content.footer,
        };

        return (
            <Fragment>
                <ChipEdit transform={transform} />
                <Header content={content.nav} />
                <Nav content={navData} />
                <div className={classnames(styles.main, 'clearfix')}>
                    <NewsStream content={newStreamData} />
                    <div className={styles.aside}>
                        <Chip
                            id={content.rightNavId}
                            type="struct"
                            title="右侧导航"
                            groupName="右侧导航"
                            content={content.rightNav}>
                            <RightNav />
                        </Chip>
                        <ContactUs content={content.contactus} />
                    </div>
                </div>
                <BottomFooter content={bottomFooterData} />
            </Fragment>
        );
    }
}

export default Layout;
